






































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import OnboardingUnitInfo from '@/components/Stats/OnboardingStats/OnboardingUnitInfo/index.vue';

@Component({
  components: {
    OnboardingUnitInfo,
  },
})
export default class OnboardingUnitTable extends Vue {
  @PropSync('onboardItems', {}) onboardItemSync!: [];

  @PropSync('onboardCount', {}) onboardCountSync!: [];

  @PropSync('selectedDateRange', {}) selectedDateRangeSync!: string;

  @PropSync('marketSelected', {}) marketSelect!: any;

  @PropSync('loading', {}) loadingSync!: boolean;

  private seeList: boolean = false;

  private headers = [
    {
      text: 'Unit Name',
      align: 'left',
      value: 'unit.name',
      width: '190px',
    },
    {
      text: 'Date',
      align: 'left',
      value: 'date',
      width: '190px',
    },
    {
      text: 'Market',
      align: 'left',
      value: 'market.name',
      width: '190px',
    },
  ];

  public onClickSee() {
    this.seeList = true;
  }
}
